import React from "react";
import GreenClubTag from "./GreenClubTag";
import i18n from "~/assets/js/Helpers/i18n";
import PropTypes from "prop-types";

function GreenClubLowerPrice({
    newPrice,
    oldPrice,
    taxRate,
    isGreenClub = true,
}) {
    return (
        <div id="product-discounted-price">
            <div className="row__price">
                <span className="price">{newPrice}</span>{" "}
                {isGreenClub && <GreenClubTag color="green" />}
            </div>
            {oldPrice && (
                <div className="row">
                    <span>
                        <span className="old-price">{oldPrice}</span>{" "}
                        {isGreenClub &&
                            i18n.t("productDetails.greenClub.normalPrice")}
                    </span>
                </div>
            )}
            <div className="row">
                <span className="tax">{taxRate}</span>
            </div>
        </div>
    );
}

GreenClubLowerPrice.propTypes = {
    newPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    oldPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    taxRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default GreenClubLowerPrice;
